import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {CANDIDATES} from "../../../../tenant/Config/ApiUrl";

const state =  {
    candidate: {},
}

const getters = {
    getCandidateDetails: state => {
        return state.candidate
    }
};

const actions = {
    getCandidateDetails({commit, state}, candidateId){
        commit('SET_LOADER', true)
        axiosGet(`${CANDIDATES}/${candidateId}`).then(({ data }) =>{
            commit('CANDIDATE_DETAILS_DATA', data)
        }).finally(()=> commit('SET_LOADER', false))
    },
}

const mutations = {
    CANDIDATE_DETAILS_DATA(state, data){
        state.candidate = data;
    },
}

export default {
    state,
    actions,
    getters,
    mutations
}
